import type { Project } from '../types/project';

interface ProjectHeaderProps {
  project: Project;
}

export function ProjectHeader({ project }: ProjectHeaderProps) {
  return (
    <div className="bg-white rounded-lg shadow-elevation-medium p-6 mb-6">
      <div className="flex items-start gap-4">
        {/* Logo placeholder - can add project logos later */}
        <div className="w-16 h-16 bg-cambrian-secondary rounded-lg flex items-center justify-center flex-shrink-0">
          <span className="text-2xl font-bold text-cambrian-primary">
            {project.symbol.slice(0, 2)}
          </span>
        </div>

        <div className="flex-1">
          <h1 className="text-3xl font-bold text-cambrian-text mb-2">
            {project.name}
            <span className="text-xl text-gray-500 ml-3">({project.symbol})</span>
          </h1>

          {/* Links */}
          <div className="flex gap-4 mt-3">
            {project.websiteUrl && (
              <a
                href={project.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-cambrian-primary hover:text-cambrian-primary-dark transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                  />
                </svg>
                Website
              </a>
            )}
            {project.twitterUrl && (
              <a
                href={project.twitterUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-cambrian-primary hover:text-cambrian-primary-dark transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
                Twitter
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
